import React from 'react';

import Icon from 'components/commons/icon/Icon';
import Modal from './Modal';
import { useLocation } from 'react-router-dom';

type MessageModalProps = {
  title: string;
  message: string[];
  onClose: () => void;
};

const MessageModal: React.FC<MessageModalProps> = props => {
  const { title, message, onClose } = props;
  const location = useLocation();

  const isReport =
    location.pathname.startsWith('/weeklyreport') ||
    location.pathname.startsWith('/monthlyreport');
  const isAssetTransition = location.pathname === '/assettransition';

  const messageView = message.map((value, index) => {
    return value === '\r\n' ? <br key={index} /> : <p key={index}>{value}</p>;
  });
  return (
    <Modal onClose={onClose}>
      <div
        onClick={event => {
          event.stopPropagation();
        }}>
        <div className="flex mt-2 mx-3 p-2">
          <div className="flex-grow text-left text-lg font-bold">{title}</div>
          <button onClick={onClose}>
            <Icon name="close" className="text-2xl text-gray-500 text-center" />
          </button>
        </div>
        <div
          className={`${isReport || isAssetTransition ? '' : 'ui-border-b'}`}>
          <div className="mb-2 mx-3 p-2">{props.children ?? messageView}</div>
        </div>
        <div
          className="flex justify-center text-gray-500 m-1 p-2 cursor-pointer"
          onClick={onClose}>
          閉じる
        </div>
      </div>
    </Modal>
  );
};

export default MessageModal;
